import { useNavigate } from 'react-router-dom';
import { LogOut, User, ChevronDown } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { useState, useRef, useEffect } from 'react';
import { cn } from '@/lib/utils';

export function Header() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { data: currentUser } = useCurrentUser();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    toast({
      title: 'Logout realizado',
      description: 'Você foi desconectado com sucesso.',
    });
    navigate('/auth');
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="h-16 border-b bg-background flex items-center justify-between px-6">
      <div className="flex items-center gap-2">
        <span className="text-sm text-muted-foreground">
          Sistema de Cobrança Inteligente
        </span>
      </div>

      <div className="relative" ref={dropdownRef}>
        <Button 
          variant="ghost" 
          className="flex items-center gap-2 px-3"
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="size-8 rounded-full bg-[hsl(var(--basic-100))] flex items-center justify-center">
            <User className="h-4 w-4 text-[hsl(var(--basic-700))]" />
          </div>
          <span className="text-sm font-medium hidden sm:inline">
            {currentUser?.full_name || currentUser?.email || 'Usuário'}
          </span>
          <ChevronDown className={cn(
            "h-4 w-4 transition-transform",
            isOpen && "rotate-180"
          )} />
        </Button>

        {isOpen && (
          <div className="absolute right-0 mt-2 w-64 rounded-xl bg-card border shadow-lg z-50">
            <div className="p-4 border-b">
              <p className="text-sm font-bold text-[hsl(var(--basic-900))]">
                {currentUser?.full_name || 'Usuário'}
              </p>
              <p className="text-xs text-muted-foreground truncate">
                {currentUser?.email}
              </p>
            </div>
            <div className="p-2">
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-2 px-3 py-2 text-sm text-muted-foreground hover:text-destructive hover:bg-[hsl(var(--careful-50))] rounded-lg transition-colors"
              >
                <LogOut className="h-4 w-4" />
                Sair do sistema
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
